import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  progress_step: 1,
  group: null,
  subscription_package: {
    id: null,
    name: null,
    services: [],
  },
  subscription_renewable: true,
  openstack_configs: [],
  admin_ui_configs: null,
  customer_ui_configs: null,
  billing_configs: null,
  billing_permissions: null,
  pending_payment: false,
}

const subscriptionAddSlice = createSlice({
  name: 'subscriptionAdd',
  initialState,
  reducers: {
    setProgressStep: (state, action) => {
      state.progress_step = action.payload.progress_step
    },
    setGroup: (state, action) => {
      state.group = action.payload.group
    },
    setSubscriptionPackage: (state, action) => {
      state.subscription_package = action.payload.subscription_package
    },
    setSubscriptionRenewable: (state, action) => {
      state.subscription_renewable = action.payload.subscription_renewable
    },
    setOpenStackConfigs: (state, action) => {
      state.openstack_configs = action.payload.openstack_configs
    },
    setAdminUiConfigs: (state, action) => {
      state.admin_ui_configs = action.payload.admin_ui_configs
    },
    setCustomerUiConfigs: (state, action) => {
      state.customer_ui_configs = action.payload.customer_ui_configs
    },
    setBillingConfigs: (state, action) => {
      state.billing_configs = action.payload.billing_configs
    },
    setBillingConfigPermissions: (state, action) => {
      state.billing_permissions = action.payload.billing_permissions
    },
    setPendingPayment: (state, action) => {
      state.pending_payment = action.payload.pending_payment
    },
    subscriptionAddReset: () => {
      return { ...initialState }
    }
  }
})

export const { 
  setProgressStep,
  setGroup,
  setSubscriptionPackage,
  setSubscriptionRenewable,
  setOpenStackConfigs,
  setAdminUiConfigs,
  setCustomerUiConfigs,
  setBillingConfigs,
  setBillingConfigPermissions,
  setPendingPayment,
  subscriptionAddReset,
} = subscriptionAddSlice.actions

export default subscriptionAddSlice.reducer